module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic02.3f98a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic02.png
// module id = 520
// module chunks = 1